import { render, staticRenderFns } from "./notice-modal.vue?vue&type=template&id=3189dd3f&scoped=true&"
import script from "./notice-modal.vue?vue&type=script&lang=ts&"
export * from "./notice-modal.vue?vue&type=script&lang=ts&"
import style0 from "./notice-modal.vue?vue&type=style&index=0&id=3189dd3f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3189dd3f",
  null
  
)

export default component.exports